import { Box } from '@mui/material';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledLoadCompleteProducts = styled(Box)`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  height: 96px;
  padding: 13px 16px;
  align-items: center;

  .types-divider {
    border-right-width: 2px;
    border-color: rgba(255, 255, 255, 0.2);
    width: 0px;
    margin: 0 12px;
  }

  @media (min-width: ${breakpoints.tablet}) {
    height: 133px;

    .types-divider {
      margin: 0 15px;
    }
  }
`;

interface IStyledLoadCompleteMainProductProps {
  textColor: string;
}

export const StyledSubContainer = styled.div`
  width: 65%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-start;

  @media (min-width: ${breakpoints.tablet}) {
    width: 60%;
  }
`;

export const StyledLoadCompleteMainProduct = styled.div<IStyledLoadCompleteMainProductProps>`
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center !important;
  max-width: 92px;

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    width: auto;
    aspect-ratio: 1/1;
    margin-bottom: 2px;

    .image {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 18px;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: 100%;
    font-weight: 700;
    text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
      1px 1px 0 #000000;

    &__stroked {
      font-size: 18px;
      margin-top: 2px;
      color: #fff;
      text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
        1px 1px 0 #000000;
      font-weight: 700;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 110%;
        height: 2px;
        background-color: #ff0000;
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    max-width: 117px;
    width: 40%;

    .image-container {
      height: 43px;
      width: auto;
      aspect-ratio: 1/1;
    }

    .quantity {
      font-size: 22px;

      &__stroked {
        font-size: 22px;
      }
    }
  }
`;

interface IStyledLoadCompleteSubProductProps {
  textColor: string;
  isOneProduct: boolean;
}

export const StyledLoadCompleteSubProduct = styled.div<IStyledLoadCompleteSubProductProps>`
  display: flex;
  gap: 2px;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  width: ${({ isOneProduct }) => (isOneProduct ? '100%' : 'max-content')};

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    min-width: 32px;
    width: 32px;
    height: 32px;
    margin-right: 2px;

    .image {
      height: 100%;
      width: 100%;
      object-fit: contain;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .quantity {
    font-size: calc(clamp(4px, 1em * 1, 14px));
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: calc(100% - 24px);
    font-weight: 700;
    text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
      1px 1px 0 #000000;
  }

  @media (min-width: ${breakpoints.tablet}) {

    .quantity {
      font-size: 18px;
    }
  }
`;
